import { formatBytes } from '@fourthwall/utils/dist/file'

export const formatSubscriptionBytes = (bytes: number) =>
  formatBytes(bytes, {
    unit: 'decimal',
    decimals: 2,
    rounding: false,
  })
